import { FC } from 'react';
import { cn } from 'shared/utils/cn.ts';

export interface LoadingSpinnerProps {
  size?: number;
  className?: string;
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 32, className = '' }) => {
  return (
    <div
      className={cn(
        'spinner animate-spin-fast border-primary inline-block rounded-full border-2 border-b-transparent border-l-transparent',
        className,
      )}
      style={{
        width: size,
        height: size,
      }}
    />
  );
};
